import { ArtifactIdType } from 'shared/constants/artifactIdType';
import { ratingTypes } from 'shared/constants/ratingTypes';

export const artifactIdToRatingType: Record<ArtifactIdType, ratingTypes> = {
  [ArtifactIdType.ScopeOneId]: ratingTypes.CREDIT_RATING,
  [ArtifactIdType.EasyNumber]: ratingTypes.CREDIT_REVIEW,
  [ArtifactIdType.EsgId]: ratingTypes.ESG_IMPACT,
};
